import { createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
import { constant } from '@app/utils/constant';

export interface AuthState {
  isLoggedIn: boolean;
  token: string | null;
  currentUser: any;
}

const initialState: AuthState = {
  isLoggedIn: !!Cookies.get(constant.Cookie_Name),
  token: Cookies.get(constant.Cookie_Name),
  currentUser: {
    email: 'mail@example.com',
    picture: null
  }
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginUser: (state, { payload }) => {
      Cookies.set(constant.Cookie_Name, payload, { domain: constant.Cookie_Domain, secure: constant.Cookie_Secure, sameSite: constant.Cookie_SameSite });
      //localStorage.setItem('token', payload);
      state.isLoggedIn = true;
      state.token = payload;
    },
    logoutUser: (state) => {
      //localStorage.removeItem('token');
      Cookies.remove(constant.Cookie_Name, { domain: constant.Cookie_Domain, secure: constant.Cookie_Secure, sameSite: constant.Cookie_SameSite });
      state.currentUser = {};
      state.isLoggedIn = false;
      state.token = null;
    },
    loadUser: (state, { payload }) => {
      state.currentUser = payload;
    }
  }
});

export const { loginUser, logoutUser, loadUser } = authSlice.actions;

export default authSlice.reducer;
